import { Workstation } from 'app/containers/OrderDetails/types';
import { ProductionPiece } from 'app/models/ProductionPiece';

export const shouldIncludeCuttingPiece = (
  piece: ProductionPiece,
  allPieces: ProductionPiece[],
): boolean => {
  if (
    piece.station !== Workstation.Drawer ||
    !piece.reference.includes('DRL')
  ) {
    return true;
  }

  const frontDrawer = allPieces.find(
    candidate =>
      candidate.trolleyName === piece.trolleyName &&
      !candidate.reference.includes('DRL') &&
      !candidate.hasDRL,
  );

  if (!frontDrawer) return true;

  frontDrawer.hasDRL = true;
  return false;
};
